import React from 'react';
import { experienceData } from '../data/mock';
import { Briefcase } from 'lucide-react';

const ExperienceCard = ({ experience, isLast }) => (
  <div className="relative pl-6 pb-8 last:pb-0">
    {/* Timeline Line */}
    {!isLast && (
      <div className="absolute left-[7px] top-8 bottom-0 w-px bg-gray-200" />
    )}
    
    {/* Timeline Dot */}
    <div className="absolute left-0 top-1.5 w-4 h-4 bg-white border-2 border-gray-300 rounded-full flex items-center justify-center">
      <div className="w-1.5 h-1.5 bg-blue-600 rounded-full" />
    </div>

    {/* Content */}
    <div className="bg-white rounded-xl border border-gray-100 p-5 hover:border-gray-200 hover:shadow-sm transition-all">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 mb-3">
        <div>
          <h3 className="text-base font-medium text-gray-900">{experience.role}</h3>
          <div className="flex items-center gap-1.5 mt-0.5">
            <Briefcase className="w-3.5 h-3.5 text-gray-400" />
            <span className="text-sm text-gray-500">{experience.company}</span>
          </div>
        </div>
        <span className="text-xs text-gray-400 font-mono whitespace-nowrap">{experience.period}</span>
      </div>

      {/* Description */}
      <p className="text-sm text-gray-500 leading-relaxed mb-3">
        {experience.description}
      </p>

      {/* Achievements as tags */}
      <div className="flex flex-wrap gap-1.5">
        {experience.achievements.map((achievement, index) => (
          <span 
            key={index} 
            className="text-xs text-gray-500 bg-gray-50 px-2 py-0.5 rounded"
          >
            {achievement}
          </span>
        ))}
      </div>
    </div>
  </div>
);

const Experience = () => {
  return (
    <section id="experience" className="py-20 lg:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12">
          <span className="text-sm font-medium text-blue-600 tracking-wide uppercase mb-2 block">
            Experience
          </span>
          <h2 className="text-3xl lg:text-4xl font-light text-gray-900 tracking-tight">
            Career journey
          </h2>
        </div>

        {/* Timeline */}
        <div className="max-w-2xl">
          {experienceData.map((experience, index) => (
            <ExperienceCard
              key={experience.id}
              experience={experience}
              isLast={index === experienceData.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
